var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMicrophoneFill24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.868 9.326v2.626a4.207 4.207 0 0 0 6.008 3.803l.843.902a5.2 5.2 0 0 1-2.454.613h-.38a5.206 5.206 0 0 1-5.205-5.196l-.001-.637a.75.75 0 0 0-1.5.002l.001.638a6.707 6.707 0 0 0 6.145 6.67v1.886a.75.75 0 0 0 1.5 0v-1.886a6.66 6.66 0 0 0 2.946-.965l1.681 1.8a.75.75 0 0 0 1.096-1.025L6.393 5.551a.75.75 0 1 0-1.096 1.025zm.817-3.86 7.382 7.816a4.2 4.2 0 0 0 .215-1.33V7.957a4.207 4.207 0 0 0-7.597-2.492Zm8.303 8.791 1.09 1.154a6.7 6.7 0 0 0 .892-3.346v-.651a.75.75 0 0 0-1.5 0v.65c0 .784-.172 1.527-.482 2.193",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophoneFill24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };